export const MIGRATE_PERCENTAGE: 'percentage' = 'percentage';
export const MIGRATE_EMAIL: 'email' = 'email';
export const MIGRATION_TYPES = {
  percentage: MIGRATE_PERCENTAGE,
  email: MIGRATE_EMAIL,
};
